import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useStockItemsRealtime } from "@/hooks/useStockItemsRealtime";

interface InterfaceModelContentProps {
  sampleData: any[];
  onDelete: (params: { id: string; newData: any[] }) => void;
  businessTypeId?: string;
  interfaceModel?: any;
}

export const InterfaceModelContent = ({
  sampleData,
  onDelete,
  businessTypeId,
  interfaceModel,
}: InterfaceModelContentProps) => {
  const [localData, setLocalData] = useState(sampleData);

  useEffect(() => {
    setLocalData(sampleData);
  }, [sampleData]);

  // Utiliser notre nouveau hook personnalisé
  useStockItemsRealtime(localData[0]?.stock_id, (updatedData) => {
    setLocalData(updatedData);
    onDelete({ id: 'dummy', newData: updatedData });
  });

  const handleSetAsDefault = async () => {
    if (!businessTypeId || !interfaceModel?.id) return;

    try {
      const { error } = await supabase
        .from('business_types')
        .update({ default_interface_model_id: interfaceModel.id })
        .eq('id', businessTypeId);

      if (error) throw error;
    } catch (error) {
      console.error("Erreur lors de la définition du modèle par défaut:", error);
    }
  };

  return (
    <div>
      <h1>Interface Model Content</h1>
      <button onClick={handleSetAsDefault}>Set as Default</button>
      <ul>
        {localData.map(item => (
          <li key={item.id}>{item.name}</li>
        ))}
      </ul>
    </div>
  );
};
